import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import keycloak from './keycloak';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Login ist optional: 'check-sso' meldet einen bestehenden SSO-Login still an,
// zwingt aber (anders als bei den anderen Fair-Apps) niemanden zum Einloggen.
keycloak.init({
  onLoad: 'check-sso',
  pkceMethod: 'S256',
  checkLoginIframe: false,
  silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
})
  .then((authenticated) => {
    root.render(<React.StrictMode><App authenticated={authenticated} /></React.StrictMode>);
  })
  .catch((err) => {
    console.error('Keycloak init failed:', err);
    // Hub bleibt trotzdem nutzbar - nur ohne Login/Hervorhebung.
    root.render(<React.StrictMode><App authenticated={false} /></React.StrictMode>);
  });
